import React, { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getUserRoles } from "utils/apiRequestBuilder";
import Layout from ".";

const RoleCheckRoute = ({ children }) => {
  const [userRoles, setUserRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const WriteRole = "MessageCentreWriter";
  const ClientWriteRole = "MessageCentreWriterClient";

  const fetchUserRoles = async () => {
    try {
      const [request, options] = await getUserRoles();
      const response = await fetch(request, options);
      if (response.status === 200) {
        const json = await response.json();
        setUserRoles(json.data.map((role) => role.name));
      } else {
        console.error("Error fetching user roles:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching user roles:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserRoles();
  }, []);

  if (loading) {
    
    return <Layout></Layout>;
  }

  return (userRoles.includes(WriteRole) || userRoles.includes(ClientWriteRole)) ? (
    children
  ) : (
    <Navigate to="/messages" state={{ from: location }} replace />
  );
};

export default RoleCheckRoute;
